import { buttonVariantToType } from '@helpers/buttonVariant';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import S from './NavigationBlock.styles';
const NavigationBlock = ({ id, theme, items, buttons }) => {
    if (!items || items.length === 0) {
        return null;
    }
    const handleChange = (e) => {
        const url = e.target.value;
        if (url) {
            window.location.href = url;
        }
    };
    return (React.createElement(S.Container, { id: id, className: theme, flush: "both" },
        React.createElement(S.MobileDropdown, null,
            React.createElement(S.SelectWrapper, null,
                React.createElement("label", { htmlFor: "nav-select", id: "nav-label" }, "Navigate to:"),
                React.createElement("select", { id: "nav-select", "aria-labelledby": "nav-label", onChange: handleChange },
                    React.createElement("option", { value: "" }, "Navigate to:"),
                    items.map((item) => (React.createElement("option", { key: item.text, value: item.url }, item.text))),
                    buttons &&
                        buttons.map((btn) => (React.createElement("option", { key: btn.text, value: btn.url }, btn.text)))))),
        React.createElement(S.Nav, null,
            React.createElement(S.List, null,
                items.map((item) => (React.createElement(S.Item, { key: item.text },
                    React.createElement(S.Link, { href: item.url, target: item.target ?? '_self' }, item.text)))),
                buttons &&
                    buttons.map((btn) => (React.createElement(S.Item, { "data-type": "button", key: btn.text },
                        React.createElement(LinkButton, { buttonType: buttonVariantToType(btn.variant), buttonSize: btn.size, href: btn.url, target: btn.target ?? '_self' }, btn.text))))))));
};
export default NavigationBlock;
